import { makeStyles } from '@material-ui/core/styles';
import { themeCommon } from '../../../styles/theme';

const useStyles = makeStyles((theme) => ({
    container: {
        position: 'relative',
    },
    containerCoin: {
        top: '50%',
        left: 'calc(100% + 20px)',
        borderRadius: '5px',
        position: 'absolute',
        transform: 'translateY(-50%)',
        [theme.breakpoints.down('sm')]: {
            left: 'calc(100% + 18px)',
        },
    },
    containerCoinOpposite: {
        left: 'unset',
        right: 'calc(100% + 21px)',
        [theme.breakpoints.down('sm')]: {
            right: 'calc(100% + 18px)',
        },
    },
    coin: {
        borderRadius: '5px',
        position: 'relative',
        boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.25)',
        padding: '5px',
        background: '#FFFFFF',
    },
    triangle: {
        position: 'absolute',
        width: '0',
        height: '0',
        top: '50%',
        left: '1px',
        borderLeft: '8px solid transparent',
        borderRight: '8px solid transparent',
        borderBottom: '16px solid #FFFFFF',
        transform: 'rotate(-90deg) translate(50%, -100%)',
        filter: 'drop-shadow(0px 0px 3px rgba(0, 0, 0, 0.25))',
        zIndex: '-1',
        [theme.breakpoints.down('sm')]: {
            borderLeft: '8px solid transparent',
            borderRight: '8px solid transparent',
            borderBottom: '16px solid #FFFFFF',
        },
    },
    triangleOpposite: {
        left: '37px',
        transform: 'rotate(-270deg) translate(-50%, -300%)',
        [theme.breakpoints.down('sm')]: {
            left: '11px',
        },
    },
    triangle2nd: {
        zIndex: 2,
        filter: 'unset',
    },
}), {
    name: 'TooltipCoinHeadContainer',
    index: 1,
})

export default useStyles